import { useMutation } from "@tanstack/react-query";
import { IMaterial, IPodcasts } from "../../../core/models/disciplines";
import { IExercise } from '../../../core/models/exercise';
import axiosInstance from "../../../core/api/axios";

type IRelatedInfo = { module: string, subject: string };

export function useRelatedContentAuxiliar(){
  const { mutate, data, isPending } = useMutation({
    mutationKey: ['get-content-related'],
    mutationFn: ({ module, subject }: IRelatedInfo) => getRelated(module, subject),
    retry: false
  })

  return { mutate, data, isPending };
}

const getRelated = async (module: string, subject: string) => {
  try {
    //const { data: { lessons } } = await axiosInstance.get(`/subareas/${module}/lessons`);
    const { data: { exercises } } = await axiosInstance.post(`/subareas/${module}/exercises?`, {page: 1});
    const { data: { workbooks } } = await axiosInstance.get(`/subareas/${module}/workbooks`);
    const { data: { podcasts } } = await axiosInstance.get(`/subareas/${module}/podcasts`);

    //const relatedLessons = lessons.filter((it: ILesson) => it.subjects[0].slug === subject);
    const relatedExercises = exercises.filter((it: IExercise) => it.subjects[0].slug === subject);
    const relatedWorkbooks = workbooks.filter((it: IMaterial) => it.subjects[0].slug === subject);
    const relatedPodcasts = podcasts.filter((it: IPodcasts) => it.subjects[0].slug === subject);

    return { 
      //lesson: relatedLessons.slice(0, 2), 
      exercise: relatedExercises.slice(0,2), 
      workbooks: relatedWorkbooks.slice(0,2),
      podcast: relatedPodcasts.slice(0,2)
    }
  } catch(e: any) {
    throw new Error(e);
  }
}